import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Paper,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { useAuth } from "../../Context/AuthContext";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import WifiProtectedSetupIcon from "@mui/icons-material/WifiProtectedSetup";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { DataObjectOutlined } from "@mui/icons-material";
import Interactionmodal from "./Interactionmodal";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const ManagersComponent = () => {
  const navigate = useNavigate();
  const [locationTypes, setlocationTypes] = useState([]);
  const [statustypes, setStatustypes] = useState([]);
  const [leadstatustypes, setleadstatustypes] = useState([]);
  const [annualincometypes, setannualincometypes] = useState([]);
  const [engagementTypes, setEngagementTypes] = useState([]);
  const { token } = useAuth();
  const [isModalOpen, setModelOpen] = useState(false);
  const [isModalOpen2, setModelOpen2] = useState(false);
  const [isModalOpen3, setModelOpen3] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [modalData, setModalData] = useState({
    data: [],
    selectedName: "",
  });
  const [modalData2, setModalData2] = useState({
    data: [],
    selectedName: "",
  });

  const [isLoadingModalData, setLoadingModalData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [referrals, setReferrals] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchReferrals = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const apiResponse = await axios.post(
        `${apiUrl}/CCE/api/v1/userEngine/users`,
        { roleId: 2 },
        {
          headers,
        }
      );
      console.log("partner");
      console.log("partner", apiResponse);
      console.log("partner");

      if (apiResponse) {
        // const apiData = apiResponse?.data?.response;
        // setReferrals(apiData);
        // ----------------------------Filteration----------------------------------------|\
        const apiData = apiResponse?.data?.response;
        const filteredReferrals = apiData.filter((referral) => {
          const fullName = `${referral.firstname} ${referral.lastname}`;
          return (
            fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            referral.email.toLowerCase().includes(searchQuery.toLowerCase())
          );
        });
        setReferrals(filteredReferrals);
        // ----------------------------------filter end-----------------------------------|\
      }

      console.log("api", apiResponse);
    } catch (error) {
      console.error("Error fetching graph data:", error.message);
    }
    setLoading(false);
  };

  // console.log("rf", apiData);
  // console.log("rf", searchQuery);
  // console.log("rf", referrals);

  useEffect(() => {
    fetchReferrals();
  }, [searchQuery]);
  //--------------------------------------
  const formatPhoneNumber = (phoneNumber) => {
    const phoneNumberString = phoneNumber?.toString() || ""; // Add null check
    if (phoneNumberString.length === 10) {
      return `${phoneNumberString.substring(
        0,
        5
      )} ${phoneNumberString.substring(5)}`;
    } else {
      return phoneNumberString;
    }
  };

  const handleIconsClick = (data, iconType) => {
    const id = data.row.id;
    const selectedName = `${data.row.firstname} ${data.row.lastname}`;
    console.log(selectedName, "data");
    const fetchReferrals = async () => {
      setLoadingModalData(true);
      setModelOpen(true);

      const headers = {
        "x-access-token": token,
      };
      try {
        const apiResponse = await axios.post(
          `${apiUrl}/CCE/api/v1/referalEngine/getAllReferral`,
          { userId: id },
          {
            headers,
          }
        );
        if (apiResponse) {
          const apiData = apiResponse?.data?.response;

          console.log(apiData, "apiData");
          setLoadingModalData(false);
          setModalData({ selectedName, data: apiData });
        }

        // console.log("api", apiResponse);
      } catch (error) {
        console.error("Error fetching graph data:", error.message);
      }
    };
    fetchReferrals();
  };
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {
        // Include any data that needs to be sent in the request body here
      });
      console.log("locationdata", response);
      setlocationTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLeadstatusData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setleadstatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getEngagementtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
      const response = await axios.get(url, {});
      // console.log("engagementdata", response);
      setEngagementTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getEngagementtypeData();
    getLocationtypeData();
    getstatustypeData();
    getLeadstatusData();
    getAnnualincomeData();
  }, []);
  const handleInteractionClick = (name, data) => {
    setModalData2({ selectedName: name, data });
    setModelOpen2(true);
  };
  const columns = [
    {
      field: "referralName",
      headerName: "Wealth Advisor Name",
      renderCell: (params) => (
        <div>
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
      width: 180,
      headerClassName: "boldHeader",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 200,
      headerClassName: "boldHeader",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      // type: "number",
      valueFormatter: (params) => formatPhoneNumber(params.value),
      width: 180,
      headerClassName: "boldHeader",
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (
        <Box>
          <Tooltip title="View Leads">
            <IconButton
              variant="outlined"
              size="small"
              onClick={() => handleIconsClick(params, "viewLeads")}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      width: 160,
      headerClassName: "boldHeader",
    },
  ];

  const leadsColumns = [
    {
      field: "referralName",
      headerName: "Referral Name",
      renderCell: (params) => (
        <div
          onClick={() => {
            const foundObject = modalData.data.find(
              (obj) => obj.id === params.row.id
            );
            console.log(
              params.row.id,
              modalData.data,
              foundObject,
              "Full row data"
            );

            handleInteractionClick(
              `${params.row.firstname} ${params.row.lastname}`,
              foundObject.interactionDetails
                ? foundObject.interactionDetails
                : []
            );
          }}
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
      width: 160,
      headerClassName: "boldHeader",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 220,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      valueFormatter: (params) => formatPhoneNumber(params.value),
      width: 180,
      headerClassName: "boldHeader",
    },
    {
      field: "created_date",
      headerName: "Added On",
      valueFormatter: (params) => formatDateString(params.value),
      width: 160,
      headerClassName: "boldHeader",
    },
    {
      field: "firstContactDate",
      headerName: "First Contact Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 160,
      headerClassName: "boldHeader",
    },
    {
      field: "referredByName",
      headerName: "RRP Name",
      width: 160,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      headerClassName: "boldHeader",
      renderCell: (params) => {
        const status = params.value;
        const capitalizedStatus = status
          ? status.charAt(0).toUpperCase() + status.slice(1)
          : "";
        return <div>{capitalizedStatus}</div>;
      },
    },
    {
      field: "sourceOfReferral",
      headerName: "Source",
      width: 160,
      headerClassName: "boldHeader",
    },
  ];
  const interactionColumns = [
    {
      field: "meeting_at",
      headerName: "Meeting Date",
      width: 150,
      headerClassName: "boldHeader",

      renderCell: (params) => (
        <div>
          <div
            onClick={() => handleOpenModal(params.row)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {formatDateString(params.value)}
          </div>
        </div>
      ),
    },

    {
      field: "location_type_engagement_type",
      headerName: "Location",
      width: 300,
      headerClassName: "boldHeader",
      renderCell: (params) => {
        const locationType =
          locationTypes.find((item) => item.id === params.row.location_type)
            ?.masterValueDesc || "";
        const engagementType =
          engagementTypes.find((item) => item.id === params.row.engagement_type)
            ?.masterValueDesc || "";

        return (
          <div>
            {engagementType}
            {locationType && `, ${locationType}`}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerClassName: "boldHeader",

      renderCell: (params) => (
        <div>
          {
            statustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "lead_status",
      headerName: "Lead Status",
      width: 150,
      headerClassName: "boldHeader",

      renderCell: (params) => {
        const status =
          leadstatustypes.find((item) => item.id === params.value)
            ?.masterValueDesc || "";
        return (
          <Tooltip title={status}>
            <div>{status}</div>
          </Tooltip>
        );
      },
    },

    {
      field: "expected_date_of_closure",
      headerName: "Exp.Dt.Closure",
      valueFormatter: (params) => formatDateString(params.value),
      width: 170,
      headerClassName: "boldHeader",
    },
    {
      field: "estimated_annual_income",
      headerName: "Est.Annual Income",
      width: 170,
      headerClassName: "boldHeader",

      renderCell: (params) => (
        <div>
          {
            annualincometypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "followup_date_n_time",
      headerName: "Follow Up Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 150,
      headerClassName: "boldHeader",
    },
    //  {
    //   field: 'action',
    //   headerName: 'Action',
    //   width: 100,
    //   renderCell: (params) => (
    //     <DeleteIcon
    //       style={{ cursor: 'pointer' }}
    //       // onClick={() => handleDeleteClickdelete(params.row.id)}
    //     />
    //   ),
    // },
  ];
  const handleOpenModal = (rowData) => {
    // console.log(rowData, "rowData");
    setSelectedData(rowData);
    // console.log("clkes inside modal");
    setModelOpen3(true);
  };

  const handleCloseModal = () => {
    setSelectedData(null);
    setModelOpen3(false);
  };

  const handleDownloadCSV = () => {
    const csvData = referrals.map((row) => ({
      "Wealth Advisor Name": `${row.firstname} ${row.lastname}`,
      "Email Address": row.email || "-",
      "Phone Number": row.phone || "-",
    }));

    return csvData;
  };
  const handleDownloadCSVForWA = () => {
    if (!modalData?.data?.length) return [];

    return modalData.data.map((row) => ({
      "Referral Name": `${row.firstname || ""} ${row.lastname || ""}`,
      "Email Address": row.email || "-",
      "Phone Number": row.phone || "-",
      "Added On": formatDateString(row.created_date) || "-",
      "First Contact Date": formatDateString(row.firstContactDate) || "-",
      "RRP Name": row.referredByName || "-",
      Status: row.status
        ? row.status.charAt(0).toUpperCase() + row.status.slice(1)
        : "-",
      Source: row.sourceOfReferral || "-",
    }));
  };

  return (
    <Box sx={styles.main_container}>
      <Paper sx={styles.dashboard_paper}>
        <h3>Wealth Advisors</h3>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btnback}
            variant="contained"
            onClick={() => navigate("/employeedashboard")}
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Box
        sx={{
          width: "100%",
          height: "92vh",
          background: "#f2f2f2",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            margin: "10px 20px 20px 20px",
            height: "590px",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 15px",
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              {/* ----------------------------Filter--------------------------------------- */}
              <Box
                sx={{
                  textAlign: "left",
                  position: "relative",
                  margin: "16px 0px",
                }}
              >
                <input
                  style={{
                    width: "200px",
                    height: "30px",
                    fontSize: "11px",
                    borderRadius: "8px",
                    paddingLeft: "35px",
                  }}
                  type="text"
                  placeholder="Search by Wealth Advisor Name / Email"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <SearchIcon
                  sx={{
                    position: "absolute",
                    left: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "grey",
                  }}
                />
                <CSVLink
                  data={handleDownloadCSV()}
                  filename="wealth advisors.csv"
                  style={{ textDecoration: "none" }}
                >
                  <Button sx={styles.btn} variant="contained">
                    Download CSV
                  </Button>
                </CSVLink>
              </Box>
              {/* ---------------------------------------------------------------------- */}
            </Box>
          </Box>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div style={{ height: 535, width: "100%" }}>
              <DataGrid
                rows={referrals}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                sx={sxStyles.boldHeader}
              />
              <Modal
                open={isModalOpen}
                onClose={() => setModelOpen(false)}
                aria-labelledby="interaction-details-modal-title"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    right: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1200,
                    maxHeight: 600,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "2px",
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#d9d9d9 #fff", // For Firefox
                    "&::-webkit-scrollbar": {
                      width: "2px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#d9d9d9",
                    },
                  }}
                >
                  {isLoadingModalData ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50%",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        right: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 1200,
                        maxHeight: 600,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: "2px",
                        scrollbarWidth: "thin", // For Firefox
                        scrollbarColor: "#d9d9d9 #fff", // For Firefox
                        "&::-webkit-scrollbar": {
                          width: "2px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#d9d9d9",
                        },
                      }}
                    >
                      <Box
                        onClick={() => setModelOpen(false)}
                        sx={{
                          textAlign: "right",
                          cursor: "pointer",
                          color: "#666666",
                        }}
                      >
                        <CloseIcon sx={{ fontSize: 30 }} />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          // sx={{ marginBottom: "20px" }}
                          id="interaction-details-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          <b>Leads for {modalData?.selectedName}</b>
                        </Typography>
                        <CSVLink
                          data={handleDownloadCSVForWA()}
                          filename={`leads for ${
                            modalData?.selectedName || "unknown"
                          }.csv`}
                          style={{ textDecoration: "none" }}
                        >
                          <Button sx={styles.btn} variant="contained">
                            Download CSV
                          </Button>
                        </CSVLink>
                      </Box>

                      {modalData?.data.length > 0 ? (
                        <div style={{ height: 400, width: "100%" }}>
                          <DataGrid
                            rows={modalData.data}
                            columns={leadsColumns}
                            getRowId={(row) => row.id}
                            autoHeight={false}
                            disableSelectionOnClick
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 15]}
                            getDetailPanelHeight={() => "auto"}
                            sx={sxStyles.boldHeader}
                          />
                        </div>
                      ) : (
                        <Typography sx={{ marginTop: "12px" }}>
                          No Leads available.
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Modal>
              <Modal
                open={isModalOpen2}
                onClose={() => setModelOpen2(false)}
                aria-labelledby="interaction-details-modal-title"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    right: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1200,
                    maxHeight: 600,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: "2px",
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#d9d9d9 #fff", // For Firefox
                    "&::-webkit-scrollbar": {
                      width: "2px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#d9d9d9",
                    },
                  }}
                >
                  {isLoadingModalData ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50%",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        right: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 1200,
                        maxHeight: 600,
                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: "2px",
                        scrollbarWidth: "thin", // For Firefox
                        scrollbarColor: "#d9d9d9 #fff", // For Firefox
                        "&::-webkit-scrollbar": {
                          width: "2px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#d9d9d9",
                        },
                      }}
                    >
                      <Box
                        onClick={() => setModelOpen2(false)}
                        sx={{
                          position: "absolute",
                          top: 16,
                          right: 16,
                          cursor: "pointer",
                          color: "#666666",
                          zIndex: 1,
                        }}
                      >
                        <CloseIcon sx={{ fontSize: 30 }} />
                      </Box>
                      <Typography
                        sx={{ marginBottom: "12px" }}
                        id="interaction-details-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        <b>Interactions for {modalData2?.selectedName}</b>
                      </Typography>

                      {modalData2 && modalData2?.data?.length > 0 ? (
                        <div style={{ height: 400, width: "100%" }}>
                          <DataGrid
                            rows={modalData2.data}
                            columns={interactionColumns}
                            getRowId={(row) => row.id}
                            autoHeight={false}
                            disableSelectionOnClick
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 15]}
                            getDetailPanelHeight={() => "auto"}
                            sx={sxStyles.boldHeader}
                          />
                        </div>
                      ) : (
                        <Typography sx={{ marginTop: "12px" }}>
                          No Interactions available.
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              </Modal>
              <Interactionmodal
                open={isModalOpen3}
                onClose={handleCloseModal}
                selectedData={selectedData}
                // onStatusUpdate={handleStatusUpdate}
              />
            </div>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default ManagersComponent;

const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btnback: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  btn: {
    width: "140px",
    margin: "10px 11px",
    fontSize: "11px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
